// Module
var code = `<template class="theme-selector">
  <require from="./theme-selector.scss"></require>
  <select label.bind="label" value.bind="theme" change.trigger="handleChange() & stopPropagation" disabled.bind="readonly" hoist-to-body>
    <option model.bind="undefined">Default</option>
    <option repeat.for="t of chartThemes" model.bind="t.name">\${t.name}</option>
  </select>
</template>
`;
// Exports
export default code;